import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="w-full px-6 md:px-10 py-20 md:py-28 bg-background-100/60">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-primary-500 bg-primary-100 px-4 py-1.5 rounded-full mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            您可能想问的
          </h2>
          <p className="text-foreground-600 text-base">
            关于一起草的常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-sm font-semibold text-foreground-950 pr-4">{faq.question}</span>
                <i
                  className={`text-foreground-400 text-lg transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <div className="pt-2 border-t border-background-200/60"></div>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-4">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}